<template>
  <v-row  class="mt-2" :class="!$vuetify.breakpoint.smAndDown ? 'mx-16' : ''">
    <v-col
      cols="12"
      xs="12"
      sm="6"
      xl="4"
      lg="4"
      md="4"
      align="center"
      v-for="(item, index) in items"
      :key="index.title"
    >
      <BlogCard :title="item.title" :desc="item.desc" :imgName="item.imageName" :link="item.link" />
      <!-- <Member :name="item.name" :job="item.job" :imgName="item.imgPath" /> -->
    </v-col>
  </v-row>
</template>

<script>
import BlogCard from "@/components/blogs/BlogCard.vue";
export default {
  components: { BlogCard },
  data() {
    return {
      items: [
        {
          title: "Helping Secure Your Sensitive Data",
          desc: "Two-Factor Authentication and Why you should be using it. Privileged information and confidentiality are synonymous with the legal industry. This make",
          imageName: "MSP-BLog.jpg",
          link :'HelpingSecureYourSensitiveData'
        },
        {
          title: "Finding the MVP of MSPs",
          desc: "It has been said that success is where preparation and opportunity meet. And, when it comes to preparation, the legal profession is a clear industry l",
          imageName: "Compass.jpg",
          link:'FindingtheMVPofMSPs'
        },
        {
          title: "Is It Time to Kick Your Server to the Curb?",
          desc: "When it comes to office partnerships, few may be as intimate as the relationship with your server. That gentle hum can be a cool tonic that soothes a",
          imageName: "shutterstock_144563243-cropped.jpg",
          link:'IsItTimetoKickYourServertotheCurb'
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>